export default __webpack_public_path__ + "static/media/burgerking.7c0a699d.svg";